import React, { useState, useEffect } from "react";
import { useNavigate, Navigate } from 'react-router-dom';
import methods from "../../../services/utility";
import apiMethod from '../../../services/api-service';

// assets
import Preloading from "../../../components/basics/Preloading";

const Profile = () => {
  const [loading, setLoading] = useState(true);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [formModel, setFormModel] = useState({
    userName: "",
    phoneNumber: "",
    id: 0,
    firstname: "",
    lastname: "",
    gender: "",
    birthDate: "",
    avatar: ""
  });
  const navigate = useNavigate();

  const isUserLogedin = methods.checkUserLogin();

  const getBaseInfo = async (id) => {
    setLoading(true);
    const resp = await apiMethod.getUserProfile(id);
    if (!methods.showApiErrors(resp)) return false;

    setFormModel({
      id: resp.data.id,
      userName: resp.data.userName,
      phoneNumber: resp.data.phoneNumber,
      firstname: resp.data.firstname,
      lastname: resp.data.lastname,
      gender: resp.data.gender,
      birthDate: resp.data.birthDate,
      avatar: resp.data.avatar
    });

    setLoading(false);
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getBaseInfo();
      setLoading(false);
    };
    bindData();
  }, []);

  const validForm = () => {
    let errors = [];
    if (methods.isNullOrEmptyString(formModel.firstname)) {
      errors.push('.نام باید مقدار داشته باشد');
    }
    if (methods.isNullOrEmptyString(formModel.lastname)) {
      errors.push('.نام‌خانوادگی باید مقدار داشته باشد');
    }
    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }
    return true;
  };

  const createNewItem = async () => {
    if (!validForm())
      return false;

    setLoading(true);

    try {
      const resp = await apiMethod.updateProfile(formModel);

      if (!methods.showApiErrors(resp))
        return false;

      navigate(-1)

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const UploadFile = async (file, attributeName) => {
    try {
      const formData = new FormData();
      formData.append("File", file);
      formData.append("FileType", 1);

      const attributeValue = formModel[attributeName];
      if (typeof attributeValue === 'string') {
        formData.append(attributeName, attributeValue);
      }
      const response = await apiMethod.uploadFile(formData);

      // Update branchData with the response data
      setFormModel((prevData) => ({
        ...prevData,
        [attributeName]: response.data,
      }));
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const changeImage = (fileOrEvent) => {
    let file;
    if (fileOrEvent instanceof File) {
      file = fileOrEvent;
    } else {
      file = fileOrEvent.target.files[0];
    }

    setFormModel((prevData) => ({
      ...prevData,
      avatar: file
    }));
    setIsImageUploading(true);

    // Upload the file
    UploadFile(file, "avatar")
      .then(() => {
        // Stop the loading state when the file is uploaded
        setIsImageUploading(false);
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
      });
  };

  const renderProfile = () => {
    return (
      <>
        {loading && <Preloading />}
        <div className="row col-lg-6 g-3 mx-auto p-3 border border-1 rounded-3">
          <div >
            <p className="border-bottom fs-3 pb-2"> ویرایش اطلاعات کاربری </p>
          </div>
          <div className="col-md-12">
            <label htmlFor="firstname" className="form-label">نام</label>
            <input type="text" className="form-control" readOnly
              id="firstname" name="firstname"
              value={formModel.firstname}
              onChange={(e) => setFormModel({ ...formModel, firstname: e.target.value })}
            />
          </div>
          <div className="col-md-12">
            <label htmlFor="lastname" className="form-label">نام خانوادگی</label>
            <input type="text" className="form-control" readOnly
              id="lastname" name="phoneNumber" 
              value={formModel.lastname}
              onChange={(e) => setFormModel({ ...formModel, lastname: e.target.value })}
            />
          </div>
          <div className='col-md-12 my-4'>
            <label htmlFor="fileUpload" className="form-label">انتخاب تصویر <br></br>
              <span style={{ fontSize: "14px" }}>
                (اندازه استاندارد  400×400  و حداکثر حجم 600kb است.)
              </span>
            </label>
            <div
              className='uploadfile'
              onDragOver={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              onDrop={(e) => {
                e.preventDefault();
                e.stopPropagation();
                const file = e.dataTransfer.files[0];
                changeImage(file);
              }}
            >
              {!isImageUploading &&
                <label htmlFor="imagefileInput" >
                  {formModel.avatar ? formModel.avatar : 'تصویر را بکشید اینجا بیاندازید'}
                  <input
                    type="file"
                    id="imagefileInput"
                    style={{ display: 'none' }}
                    name="imagefileInput"
                    accept=".jpg, .jpeg, .png"
                    onChange={(e) => changeImage(e.target.files[0])}
                  />
                </label>
              }
              {isImageUploading && (
                <div className="uploadfileloading form-control border-0">
                  <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                  <span role="status"> در حال بارگذاری ... </span>
                </div>
              )}
            </div>
          </div>
          <div className='d-flex justify-content-end align-items-baseline my-5'>
            <button
              type="button"
              className="btn custome-btn btn-link-purple ms-2"
              onClick={() => navigate(-1)}
            >
              انصراف
            </button>
            {isImageUploading ?
              <button type="submit" className="btn custome-btn btn-purple" disabled> ذخیره</button>
              :
              <button type="submit" className="btn custome-btn btn-purple"
                onClick={() => { createNewItem() }}
              > ذخیره</button>
            }
          </div>
        </div>
      </>
    )
  };

  return (
    <div className='container'>
      {isUserLogedin ?
        <div className='mt-5'>
          {renderProfile()}
        </div>
        :
        <Navigate to="/login" />
      }
    </div>
  );
}

export default Profile;